// TSS vite/03 §"Query keys convention".
// Tuples, entity-name first ('donors' — matches the backend resource
// public/donors), scope narrowing rightward. Mirrors parcerias/queries/keys.js.

export const donorKeys = {
    all:    ['donors'],
    list:   (filters) => ['donors', filters],
    // detail acepta filtros opcionales (from/to, rango por fecha OPU) para que
    // el dashboard con rango cachee aparte; invalidar con donorKeys.detail(id)
    // alcanza ambas formas (prefix match de TanStack Query).
    detail: (id, filters) => (filters ? ['donors', id, filters] : ['donors', id]),
    // Agregado del lote (public/stats?view=kpi → data.donors_kpi).
    kpi:    () => ['donors', 'kpi'],
};
